import { Typography, Link, ListItemText } from '@mui/material';
import {
  phoneNumber,
  mainPageLink,
  contactLink,
  phoneNumberString
} from '../utils/urls';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const ComplaintProcedure = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      9. Postępowanie reklamacyjne.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>9.1.</ListItemIcon>
        <ListItemText>
          Użytkownik może składać w każdym czasie zastrzeżenia dotyczące Usług.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>9.2.</ListItemIcon>
        <ListItemText>
          Reklamacja może być złożona:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                osobiście w każdej placówce BEST S.A. wskazanej na stronie
                internetowej
                <Link
                  href={mainPageLink}
                  color="primary.light"
                  target="_blank"
                  rel="nofollow"
                  data-link-no-alert
                >
                  {' '}
                  {mainPageLink}
                </Link>
                , lub
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                pisemnie – na adres korespondencyjny BEST S.A. ul. Stoczniowa 2,
                82–300 Elbląg lub
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                telefonicznie – pod numerem
                <Link href={`tel:${phoneNumber}`} data-link-no-alert>
                  {' '}
                  {phoneNumberString}
                </Link>
                , lub
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d)</ListItemIcon>
              <ListItemText>
                elektronicznie – za pośrednictwem wiadomości e–mail na adres:
                <Link href={`mailto:${contactLink}`} data-link-no-alert>
                  {' '}
                  {contactLink}
                </Link>
                .
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>9.3.</ListItemIcon>
        <ListItemText>
          Reklamacja powinna zawierać dane umożliwiające weryfikację Użytkownika
          składającego Reklamację, w szczególności imię i nazwisko lub nazwę
          firmy, adres zamieszkania lub miejsca prowadzenia działalności
          gospodarczej oraz opis przedmiotu Reklamacji.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>9.4.</ListItemIcon>
        <ListItemText>
          Odpowiedź na Reklamację jest udzielana bez zbędnej zwłoki, jednak nie
          później niż w terminie 30 dni od chwili otrzymania Reklamacji, chyba
          że z przepisów powszechnie obowiązującego prawa wynikają inne terminy
          udzielania odpowiedzi (informacji).
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>9.5.</ListItemIcon>
        <ListItemText>
          W szczególnie skomplikowanych przypadkach, uniemożliwiających
          rozpatrzenie reklamacji i udzielenie odpowiedzi w terminie 30 dni,
          Administrator zawiadomi Użytkownika o nowym terminie rozpatrzenia
          Reklamacji, który nie może jednak przekroczyć 60 dni od dnia
          otrzymania Reklamacji, chyba że z przepisów powszechnie obowiązującego
          prawa wynikają inne reguły dotyczące przedłużania terminu na
          udzielenie odpowiedzi (informacji).
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>9.6.</ListItemIcon>
        <ListItemText>
          Odpowiedź na Reklamację jest udzielana na wskazany przez Użytkownika
          adres poczty elektronicznej, a gdy w jej treści Użytkownik złoży taki
          wniosek w formie pisemnej na wskazany adres korespondencyjny, chyba że
          z przepisów powszechnie obowiązującego prawa wynikają inne reguły
          dotyczące formy odpowiedzi (informacji).
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default ComplaintProcedure;
